import React, { useState } from 'react';
import StandardLayout from '../components/common/StandardLayout';
import PageHeader from '../components/common/PageHeader';
import TabbedBasketManager from '../components/basket/TabbedBasketManager';
import Button from '../components/ui/Button';
import ImportBasketDialog from '../components/basket/ImportBasketDialog';
import { Plus, RefreshCw, Home, Package, ShoppingBasket, Download } from 'lucide-react';

const BasketsPage: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [importOpen, setImportOpen] = useState(false);

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  const actions = (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        onClick={handleRefresh}
        leftIcon={<RefreshCw className="h-4 w-4" />}
        size="sm"
      >
        Refresh
      </Button>
      <Button
        variant="outline"
        leftIcon={<Download className="h-4 w-4" />}
        onClick={() => setImportOpen(true)}
        size="sm"
      >
        Import
      </Button>
      <Button
        leftIcon={<Plus className="h-4 w-4" />}
        onClick={() => {
          const event = new CustomEvent('openCreateBasketDialog');
          window.dispatchEvent(event);
        }}
        size="sm"
      >
        Create Basket
      </Button>
    </div>
  );

  return (
    <StandardLayout>
      <PageHeader
        title="Basket Management"
        pageType="management"
        icon={<ShoppingBasket className="w-5 h-5" />}
        breadcrumbs={[
          { label: 'Home', href: '/', icon: <Home className="w-4 h-4" /> },
          { label: 'Basket Management', icon: <Package className="w-4 h-4" /> }
        ]}
        actions={actions}
      />
      <TabbedBasketManager key={refreshKey} />

      {/* Import basket wizard — page-level so the user can import without
          first selecting a basket. On success we bump refreshKey to force
          TabbedBasketManager to remount and pick up the new basket. */}
      <ImportBasketDialog
        isOpen={importOpen}
        onClose={() => setImportOpen(false)}
        onImported={() => setRefreshKey(prev => prev + 1)}
      />
    </StandardLayout>
  );
};

export default BasketsPage;
